export default __webpack_public_path__ + "static/media/blurredPink.01fd15a4.png";